import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoadingSpinner from './components/ui/LoadingSpinner';

// Lazy load pages
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const HomePage = React.lazy(() => import('./pages/HomePage'));
const AccountsPage = React.lazy(() => import('./pages/AccountsPage'));
const AccountDetailPage = React.lazy(() => import('./pages/AccountDetailPage'));
const BotsPage = React.lazy(() => import('./pages/BotsPage'));
const BotDetailPage = React.lazy(() => import('./pages/BotDetailPage'));
const ClientsPage = React.lazy(() => import('./pages/ClientsPage'));
const ClientDetailPage = React.lazy(() => import('./pages/ClientDetailPage'));
const MarketRegimePage = React.lazy(() => import('./pages/MarketRegimePage'));
const MonitoringPage = React.lazy(() => import('./pages/MonitoringPage'));
const NewsPage = React.lazy(() => import('./pages/NewsPage'));
const AppsPage = React.lazy(() => import('./pages/AppsPage'));
const AdminPage = React.lazy(() => import('./pages/AdminPage'));

function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <div className="min-h-screen bg-gray-50">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<LoginPage />} />

              {/* Main tabs */}
              <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
              <Route path="/accounts" element={<ProtectedRoute requireAdmin><AccountsPage /></ProtectedRoute>} />
              <Route path="/accounts/:id" element={<ProtectedRoute requireAdmin><AccountDetailPage /></ProtectedRoute>} />
              <Route path="/bots" element={<ProtectedRoute><BotsPage /></ProtectedRoute>} />
              <Route path="/bots/:id" element={<ProtectedRoute><BotDetailPage /></ProtectedRoute>} />
              <Route path="/clients" element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
              <Route path="/clients/:id" element={<ProtectedRoute><ClientDetailPage /></ProtectedRoute>} />
              <Route path="/market-regime" element={<ProtectedRoute><MarketRegimePage /></ProtectedRoute>} />
              <Route path="/monitoring" element={<ProtectedRoute><MonitoringPage /></ProtectedRoute>} />
              <Route path="/news" element={<ProtectedRoute><NewsPage /></ProtectedRoute>} />
              <Route path="/apps" element={<ProtectedRoute><AppsPage /></ProtectedRoute>} />

              {/* Hidden admin (direct URL only) */}
              <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </div>
      </WebSocketProvider>
    </AuthProvider>
  );
}

export default App;
